import { useMemo } from 'react';
import { List, ListItem } from '@mui/material';
import { ISelectOption } from '@shared/inputs/Select';
import { Modal } from '@shared/components/modals/Modal';
import { ILeads } from '@modules/admin/LCMenu/MyLCQueues/types';
import { IContactListItem } from '../../queries';

interface IAssignContactsModal {
  handleClose: () => void;
  handleConfirm: () => void;
  selectedUser?: ISelectOption;
  selectedContacts?: IContactListItem[];
  selectedLeads?: ILeads[];
  isLeadQueue?: boolean;
  loading?: boolean;
}

interface ICommonRecord {
  lastName?: string;
  firstName?: string;
  id?: string;
  leadId?: string;
  leadNumericId?: string;
}

export const AssignContactsModal = ({
  handleClose,
  handleConfirm,
  selectedUser,
  selectedContacts = [],
  selectedLeads = [],
  isLeadQueue = false,
  loading = false
}: IAssignContactsModal) => {
  const selectedData = !isLeadQueue ? selectedContacts: selectedLeads;

  const selectedValues: ICommonRecord[] = useMemo(() => selectedData.map(item => ({
    ...item,
    id: isLeadQueue ? item.leadId : item.id,
  })), [selectedData, isLeadQueue]);
  
  return (
    <Modal
      open
      showFooter
      buttonText="Yes"
      cancelButtonText="No"
      title={isLeadQueue? 'Assign Lead':'Assign Contacts'}
      dialogWidth="500px"
      isSubmitting={loading}
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <div>Do you want to assign the following {isLeadQueue ? 'leads' : 'contacts'} to {selectedUser?.name}?</div>
      <List sx={{ listStyleType: 'disc', marginLeft: '30px' }}>
        {selectedValues.map((data) => (
          <ListItem key={data.id} sx={{ display: 'list-item', padding: '5px 0' }}>
            {isLeadQueue ? `${data?.leadNumericId}` : `${data.firstName} ${data.lastName}`}
          </ListItem>
        ))}
      </List>
    </Modal>
  );
};
